import * as React from 'react';
/**
 * The SelectMultiple context shares details about the selected days when in
 * multiple selection mode.
 *
 * Access this context from the [[useSelectMultiple]] hook.
 */
export var SelectMultipleContext = React.createContext(undefined);
//# sourceMappingURL=SelectMultipleContext.js.map